import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LogsRoutingModule} from "./logs-routing.module";
import {SearchModule} from '../search/search.module';
import {MatTableModule} from '@angular/material/table';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatSortModule} from '@angular/material/sort';
import {MatTooltipModule} from '@angular/material/tooltip';
import {LocalDatePipe} from './logs-audit/local-date.pipe';
import {SharedModule} from "../shared/shared.module";
import { AuditDetailComponent } from './logs-audit/audit-detail/audit-detail.component';
import { MatDialogModule } from '@angular/material/dialog';


@NgModule({
  declarations: [LogsRoutingModule.components, LocalDatePipe, AuditDetailComponent],
  imports: [
    CommonModule,
    LogsRoutingModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatTooltipModule,
    MatDialogModule,
    SearchModule,
    SharedModule
  ],
  exports: [LogsRoutingModule.components]
})
export class LogsModule {
}
